import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './HomeShopInterrupt.scss';

import { openNewCircleModal } from '../../../Actions/UIActions';

const HomeShopInterrupt = props => {
  const { type } = props;

  let actions = [];

  if (type === 'FINDS_WORTH_SHARING') {
    actions = [
      {
        display: 'Create a Circle',
        onClick: () => props.openNewCircleModal({ source: 'Home Featured Circles Interrupt' })
      }
    ];
  }
  return (
    <div className='home-shop-interrupt-outer-container'>
      <img className='home-shop-interrupt-background-image' src='http://static.shopmy.us/Circles/sub.jpg' />
      <div className='home-shop-interrupt-inner-container'>
        <div className='title'>
          The <i>best</i> things in life <br />
          are worth sharing.
        </div>
        <div className='actions'>
          {actions.map(action => {
            return (
              <div key={action.label} onClick={action.onClick} className='action'>
                {action.display}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

HomeShopInterrupt.propTypes = {
  // From Outside
  type: PropTypes.oneOf(['FINDS_WORTH_SHARING']),

  // From Inside
  user: PropTypes.object.isRequired,
  openNewCircleModal: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const { user } = state;
  return { user };
};

export default connect(mapStateToProps, {
  openNewCircleModal
})(HomeShopInterrupt);
